import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectSaleType = createSelector([selectConfigurationState], (state) => state.saleType)
